import { useSearchParams } from '@remix-run/react';
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const sortOptions = [
  { labelKey: 'components.filter.sort_options.by_position', value: '' },
  { labelKey: 'components.filter.sort_options.most_sold', value: 'order_by=sold_units&sort=desc' },
  { labelKey: 'components.filter.sort_options.newest_first', value: 'order_by=product_created_at&sort=desc' },
  { labelKey: 'components.filter.sort_options.cheapest_first', value: 'order_by=price&sort=asc' },
  { labelKey: 'components.filter.sort_options.most_expensive_first', value: 'order_by=price&sort=desc' },
];

const ProductToolbar: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const sortValue = useMemo(() => {
    for (const opt of sortOptions) {
      if (!opt.value) continue;

      const optParams = new URLSearchParams(opt.value);
      const allMatch = [...optParams.entries()].every(([key, value]) => searchParams.get(key) === value);

      if (allMatch) return opt.value;
    }

    return '';
  }, [searchParams]);

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const nextParams = new URLSearchParams(searchParams);

    // remove all sort-related params
    const keysToDelete = new Set<string>();
    sortOptions.forEach((opt) => {
      if (!opt.value) return;
      new URLSearchParams(opt.value).forEach((_, key) => keysToDelete.add(key));
    });
    keysToDelete.forEach((key) => nextParams.delete(key));

    // Reset to page 1 when sort changes
    nextParams.delete('page');

    const selected = e.target.value;
    if (selected) {
      new URLSearchParams(selected).forEach((value, key) => {
        nextParams.set(key, value);
      });
    }

    setSearchParams(nextParams, { preventScrollReset: true });
  };

  return (
    <div className="product-toolbar">
      <Form.Label className="sort-select__label" htmlFor="sort-select">
        {t('components.filter.sort_by')}:
      </Form.Label>
      <Form.Select onChange={handleSortChange} value={sortValue} id="sort-select">
        {sortOptions.map((opt) => (
          <option key={opt.labelKey} value={opt.value}>
            {t(opt.labelKey)}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

export default ProductToolbar;
